import React from "react";
import LoadingLogo from "./LoadingLogo";
import styles from './LoadingScreen.module.scss'; 

export default function LoadingScreen() {

    return (
        <div className={styles["container"]}>
            <LoadingLogo />
        </div>
    )
}

